import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
import { Insights } from '../components/Insights';
export function InsightsPage() {
  return <div className="w-full pt-20 lg:pt-24" data-id="element-257">
      {/* Page Header */}
      <div className="bg-navy py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="max-w-7xl mx-auto" data-id="element-259">
          <div className="font-sans text-sm font-semibold text-white/50 uppercase tracking-wider mb-4" data-id="element-260">
            <Link to="/" className="hover:text-gold transition-colors" data-id="element-261">
              Home
            </Link>
            <span className="mx-2 text-gold/50" data-id="element-262">/</span>
            <span className="text-gold" data-id="element-263">Insights & Policy Updates</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl text-white font-bold" data-id="element-264">
            Insights & Policy Updates
          </h1>
          <div className="h-1 w-24 bg-gold mt-6" data-id="element-265"></div>
        </div>
      </div>

      {/* Featured Analysis */}
      <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="max-w-7xl mx-auto" data-id="element-267">
          <div className="mb-12" data-id="element-268">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-269">
              Featured Analysis
            </span>
          </div>
          <div className="bg-white rounded-card shadow-sm border border-cream-dark overflow-hidden flex flex-col lg:flex-row group cursor-pointer hover:shadow-md transition-shadow" data-id="element-270">
            <div className="lg:w-1/2 h-64 lg:h-auto relative overflow-hidden" data-id="element-271">
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80" alt="Modern African cityscape" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-272" />
            </div>
            <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center" data-id="element-273">
              <span className="font-sans text-xs font-bold text-gold uppercase tracking-widest mb-3" data-id="element-274">
                Special Report
              </span>
              <h2 className="font-serif text-2xl lg:text-3xl text-navy font-bold mb-4 leading-snug" data-id="element-275">
                <span className="gold-underline" data-id="element-276">
                  The 2026 West Africa Investment Outlook: Navigating
                  Opportunity and Risk
                </span>
              </h2>
              <p className="font-sans text-text-muted leading-relaxed mb-6" data-id="element-277">
                Our annual flagship report examines the macroeconomic trends,
                regulatory shifts, and sector-specific opportunities shaping the
                investment landscape in Nigeria and Ghana for the year ahead.
                Includes proprietary data from our on-the-ground research teams.
              </p>
              <div className="flex items-center gap-4 mb-6" data-id="element-278">
                <span className="font-sans text-sm text-gray-400" data-id="element-279">
                  January 2026
                </span>
                <span className="text-gray-300" data-id="element-280">•</span>
                <span className="font-sans text-sm text-gray-400" data-id="element-281">
                  48 pages
                </span>
              </div>
              <div className="flex items-center text-navy font-sans font-semibold text-sm uppercase tracking-wide group-hover:text-gold transition-colors" data-id="element-282">
                Read Full Report <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-283" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Insights Component (existing 3-column grid) */}
      <Insights data-id="element-284" />

      {/* Policy Calendar */}
      <section className="py-20 bg-cream-dark px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="max-w-7xl mx-auto" data-id="element-286">
          <div className="text-center mb-16" data-id="element-287">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-288">
              Stay Informed
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6" data-id="element-289">
              Upcoming Policy Events
            </h2>
            <div className="h-1 w-24 bg-gold mx-auto" data-id="element-290"></div>
          </div>

          <div className="space-y-4 max-w-4xl mx-auto" data-id="element-291">
            <div className="bg-white rounded-card p-6 shadow-sm border border-gray-100 flex flex-col md:flex-row md:items-center gap-4 md:gap-8" data-id="element-292">
              <div className="flex items-center gap-3 md:w-48 flex-shrink-0" data-id="element-293">
                <CalendarIcon className="h-5 w-5 text-gold flex-shrink-0" data-id="element-294" />
                <span className="font-sans font-semibold text-navy text-sm" data-id="element-295">
                  April 15, 2026
                </span>
              </div>
              <div className="flex-grow" data-id="element-296">
                <h3 className="font-serif text-lg text-navy font-semibold" data-id="element-297">
                  Nigeria Finance Act 2026 — Implementation Deadline
                </h3>
                <p className="font-sans text-sm text-text-muted mt-1" data-id="element-298">
                  Key tax reform provisions take effect, impacting foreign
                  investment structures and transfer pricing rules.
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-299">
                <MapPinIcon className="h-4 w-4 text-gray-400" data-id="element-300" />
                <span className="font-sans text-xs text-gray-400" data-id="element-301">Abuja</span>
              </div>
            </div>

            <div className="bg-white rounded-card p-6 shadow-sm border border-gray-100 flex flex-col md:flex-row md:items-center gap-4 md:gap-8" data-id="element-302">
              <div className="flex items-center gap-3 md:w-48 flex-shrink-0" data-id="element-303">
                <CalendarIcon className="h-5 w-5 text-gold flex-shrink-0" data-id="element-304" />
                <span className="font-sans font-semibold text-navy text-sm" data-id="element-305">
                  May 8–10, 2026
                </span>
              </div>
              <div className="flex-grow" data-id="element-306">
                <h3 className="font-serif text-lg text-navy font-semibold" data-id="element-307">
                  AfCFTA Business Forum — Accra
                </h3>
                <p className="font-sans text-sm text-text-muted mt-1" data-id="element-308">
                  Annual gathering of trade ministers, business leaders, and
                  investors to discuss continental trade integration progress.
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-309">
                <MapPinIcon className="h-4 w-4 text-gray-400" data-id="element-310" />
                <span className="font-sans text-xs text-gray-400" data-id="element-311">Accra</span>
              </div>
            </div>

            <div className="bg-white rounded-card p-6 shadow-sm border border-gray-100 flex flex-col md:flex-row md:items-center gap-4 md:gap-8" data-id="element-312">
              <div className="flex items-center gap-3 md:w-48 flex-shrink-0" data-id="element-313">
                <CalendarIcon className="h-5 w-5 text-gold flex-shrink-0" data-id="element-314" />
                <span className="font-sans font-semibold text-navy text-sm" data-id="element-315">
                  June 22, 2026
                </span>
              </div>
              <div className="flex-grow" data-id="element-316">
                <h3 className="font-serif text-lg text-navy font-semibold" data-id="element-317">
                  US-Nigeria Business Council Summit
                </h3>
                <p className="font-sans text-sm text-text-muted mt-1" data-id="element-318">
                  High-level dialogue on bilateral trade priorities, investment
                  protection agreements, and sector-specific partnerships.
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-319">
                <MapPinIcon className="h-4 w-4 text-gray-400" data-id="element-320" />
                <span className="font-sans text-xs text-gray-400" data-id="element-321">
                  Washington, D.C.
                </span>
              </div>
            </div>

            <div className="bg-white rounded-card p-6 shadow-sm border border-gray-100 flex flex-col md:flex-row md:items-center gap-4 md:gap-8" data-id="element-322">
              <div className="flex items-center gap-3 md:w-48 flex-shrink-0" data-id="element-323">
                <CalendarIcon className="h-5 w-5 text-gold flex-shrink-0" data-id="element-324" />
                <span className="font-sans font-semibold text-navy text-sm" data-id="element-325">
                  July 14, 2026
                </span>
              </div>
              <div className="flex-grow" data-id="element-326">
                <h3 className="font-serif text-lg text-navy font-semibold" data-id="element-327">
                  Ghana Petroleum Revenue Management Review
                </h3>
                <p className="font-sans text-sm text-text-muted mt-1" data-id="element-328">
                  Parliamentary review of petroleum revenue allocation with
                  implications for energy sector investment frameworks.
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-329">
                <MapPinIcon className="h-4 w-4 text-gray-400" data-id="element-330" />
                <span className="font-sans text-xs text-gray-400" data-id="element-331">Accra</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subscribe Section */}
      <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-332">
        <div className="max-w-3xl mx-auto text-center" data-id="element-333">
          <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-4" data-id="element-334">
            Subscribe to Market Intelligence
          </h2>
          <p className="font-sans text-lg text-text-muted mb-8" data-id="element-335">
            Receive our latest policy briefs, regulatory updates, and market
            analysis directly to your inbox every week.
          </p>

          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto" onSubmit={e => e.preventDefault()} data-id="element-336">
            <input type="email" placeholder="Enter your email address" className="flex-grow bg-white border border-gray-300 rounded-card px-4 py-3 font-sans focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold" required data-id="element-337" />
            <button type="submit" className="bg-navy hover:bg-navy-deep text-white font-sans font-bold text-sm uppercase tracking-wide px-8 py-3 rounded-card transition-colors whitespace-nowrap" data-id="element-338">
              Subscribe
            </button>
          </form>
          <p className="font-sans text-xs text-gray-500 mt-4" data-id="element-339">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </section>
    </div>;
}